export const oxgGetDaysUntil = (givenDate, format = 'dd.mm.yyyy')=> {
    const today = new Date();
    let isDate = false;
    today.setHours(0, 0, 0, 0);

    if(givenDate == '') {
        result = 'missing'
        return result;
    }

    let date = null;

    if (givenDate instanceof Date) {
        date = givenDate
    } else {
        console.log(givenDate);
        let parts = givenDate.split('.')
        if ( parts.length != 3 ) {
            result = 'invalid'
            return result;
        }
        let year, month, day;
        
        if ( format == 'dd.mm.yyyy' || format == 'd.m.yyyy' || format == 'd.m.yy') {
            day = parseInt(parts[0], 10)
            month = parseInt(parts[1], 10) - 1
            year = parseInt(parts[2], 10)
        } else {
            month = parseInt(parts[0], 10) - 1
            day = parseInt(parts[1], 10)
            year = parseInt(parts[2], 10)
        }
    
        date = new Date(year, month, day); 
    }

    if(date == 'Invalid Date') {
        result = 'invalid'
        return result;
    }
    date.setHours(0, 0, 0, 0);

    const diffTime = date - today;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    let result;
    if (diffDays === 0) {
        result = 'today';
    } else {
        result = diffDays;
    }

    return result;
}

export const oxgGetTodayPlusDays = (days)=> {
    //if (typeof(NumberOfDays) != 'integer' ) return
    let today = new Date();
    today.setDate(today.getDate() + days)
    return today;
}